import { Component } from '@angular/core';
import { ItemMenu } from '../../core/data';
import { Menu } from '../../core/data/data';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ScrollService } from '../../core/shared/services/scroll_to_id.service';
import { NgOptimizedImage } from '@angular/common';
import { RevealDirective } from '../../core/shared/directive/reveal.directive';

@Component({
    selector: 'app-footer',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, NgOptimizedImage, RevealDirective],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    providers: [ScrollService]
})
export class FooterComponent {
    menu: ItemMenu[] = Menu;

    contacts: { icon: string; text: string; href?: string }[] = [
        {
            icon: 'assets/images/ic_contact_location.svg',
            text: 'Head Office: Room 403, 4th Floor, No. 21–23 Nguyen Cong Hoan Street, Giang Vo Ward, Hanoi, Vietnam.',
        },
        {
            icon: 'assets/images/ic_contact_office.svg',
            text: 'Office Address: 4th Floor, Office Area, Stellar Garden Building, No. 35 Le Van Thiem Street, Thanh Xuan Ward, Hanoi, Vietnam.',
        },
        {
            icon: 'assets/images/ic_contact_mail.svg',
            text: 'contact@govo.tech',
            href: 'mailto:contact@govo.tech',
        },
        { icon: 'assets/images/ic_contact_phone.svg', text: 'Phone: 0876 193 995' },
        { icon: 'assets/images/ic_contact_tax.svg', text: 'Tax code: 0110711694' },
    ];

    constructor(private scrollToId: ScrollService) {}

    scrollToSection(id: string) {
        return this.scrollToId.scrollToSection(id);

    }
}
